import { AppstoreOutlined } from '@ant-design/icons'
import Platform from '@/features/platform/page'
import { permissions } from '@/types/authorization'
import type { ProtectedRouteDescriptor } from '@/routes/types'

export const integrationsRoutes: ProtectedRouteDescriptor[] = [
  {
    key: 'platform',
    path: 'platform',
    element: <Platform />,
    access: { anyOf: [permissions.viewPlatform, permissions.viewPlatformLog] },
    nav: {
      sectionKey: 'integrations',
      label: 'Platform',
      Icon: AppstoreOutlined,
      order: 10,
    },
  },
]
